
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import InvoiceUpload from './invoiceUpload.vue';
import lazyInject from '@/di';
import InvoiceService from '@/services/invoice.service';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    InvoiceUpload,
    Viewer,
  },
})
export default class InvoiceModal extends Vue {
  visible = false;

  moment = moment;

  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  labelCol = { span: 4 };

  wrapperCol = { span: 14 };

  title = '';

  type = '';

  status = 0;

  invoice_category = 0;

  height = 500;

  form: any = {
    tel: '',
    bank: '',
    email: '',
    title: '',
    tax_no: '',
    account: '',
    address: '',
    phone: '',
    license: '',
  };

  license: any[] = [];

  async init(value: any, type: string) {
    this.title = '发票详情';
    this.height = 500;
    // this.form = value;
    this.type = type;
    this.status = value.status;
    this.invoice_category = value.invoice_category;
    const res = await this.invoiceService.getInvoiceManageDetail(value.id);
    const _d = Object.assign({}, res, res.buyer);
    this.form = _d;
    this.visible = true;
    this.license = [
      {
        url: res.buyer.license,
        id: 0,
      },
    ];
  }

  disabledDate(current: any) {
    // Can not select days after today and today
    return current && current > moment().endOf('day');
  }

  handRecord: any = {};
  changeDate(date: moment.Moment) {
    // console.log(date);
    this.handRecord = date;
  }

  cancel() {
    this.visible = false;
  }

  async handleAudit() {
    const res = await this.invoiceService.invoiceManageAudit({ id: this.form.id });
    if (res) {
      this.$message.success('标记成功');
      this.cancel();
      this.$emit('refresh');
    }
  }
}
